export {
  Switch,
  renderSwitch_unstable,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  switchClassName,
  switchClassNames,
  useSwitchStyles_unstable,
  useSwitch_unstable,
  useSwitchBase_unstable,
} from './Switch';
export type {
  SwitchOnChangeData,
  SwitchProps,
  SwitchSlots,
  SwitchState,
  SwitchBaseProps,
  SwitchBaseState,
} from './Switch';
